import { render, staticRenderFns } from "./TermOfPayment.vue?vue&type=template&id=08792a1c&"
import script from "./TermOfPayment.vue?vue&type=script&lang=js&"
export * from "./TermOfPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports